var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mdb-select',{attrs:{"label":_vm.label,"multiple":_vm.multiple},on:{"change":_vm.onChange},model:{value:(_vm.valueArray),callback:function ($$v) {_vm.valueArray=$$v},expression:"valueArray"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }